const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`53fbdaa0a31ea0302ea586ec8b16956386b3595af6e9a7dd1170e0eda145f9bb`, `53fbdaa0a31ea0302ea586ec8b16956386b3595af6e9a7dd1170e0eda145f9bb`, 1, 88), undefined, false, false, 1));
            }

            getTemplateName() {
                return `53fbdaa0a31ea0302ea586ec8b16956386b3595af6e9a7dd1170e0eda145f9bb`;
            }

            getSourceContext() {
                return new this.Source(``, `53fbdaa0a31ea0302ea586ec8b16956386b3595af6e9a7dd1170e0eda145f9bb`, ``);
            }
        }],
        [88, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/page/page.twig`, `53fbdaa0a31ea0302ea586ec8b16956386b3595af6e9a7dd1170e0eda145f9bb`, 1);

                this.blocks = new Map([
                    ['header', [this, 'block_header']],
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/page/page.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_header(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p class="u-pad-1 t-dark">
      Header content.
    </p>
  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p class="u-pad-1">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque eu ex
      enim. Nunc efficitur scelerisque dolor et sollicitudin. Donec finibus
      lorem elit, eu consectetur quam pellentesque sed. Pellentesque habitant
      morbi tristique senectus et netus et malesuada fames ac turpis egestas.
    </p>
  `);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p class="u-pad-1 t-dark">
      Footer content.
    </p>
  `);
            }

            getTemplateName() {
                return `53fbdaa0a31ea0302ea586ec8b16956386b3595af6e9a7dd1170e0eda145f9bb`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `53fbdaa0a31ea0302ea586ec8b16956386b3595af6e9a7dd1170e0eda145f9bb`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '53fbdaa0a31ea0302ea586ec8b16956386b3595af6e9a7dd1170e0eda145f9bb');

let template = env.loadTemplate('53fbdaa0a31ea0302ea586ec8b16956386b3595af6e9a7dd1170e0eda145f9bb');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/page/demo/example.twig", args: context }
     );
     return rendered;;
};